import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
Vue.config.productionTip = false



// 跳转后返回顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

//或者
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
